var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanweituila(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53334 4.71109L0.755562 7.91109V10.2666L6.8889 15.1555L15.2889 10.2666V8.17776L8.53334 4.71109Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.844452 7.86667L8.57779 4.75555L15.3333 8.26666L6.84445 12.8L0.844452 7.86667Z",
    fill: "#95E3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666672 7.82222V9.46667V10.2222L6.84445 15.2L15.2445 10.2222V8.17778L8.48889 4.75555L0.666672 7.82222Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.755562 7.86667L6.80001 12.7556L15.2889 8.31111",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8889 15.1556V12.7111",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4444 4.31111L7.73334 0L4.8 4.31111H6.35556V8.48889H8.97778V4.31111H10.4444Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanweituila);
export default __webpack_public_path__ + "static/media/sanweituila.56d4879c272947890eccd9b5e1998054.svg";
export { ForwardRef as ReactComponent };